module.exports = __webpack_public_path__ + "static/irishCounterMelody-2bae7d08253839faee09ebc683f2d482.mp3";